import { gql, useQuery } from "@apollo/client";
import { Label, Paragraph } from "evergreen-ui";
import React from "react";
import { getDateWithTime } from "src/utilities";

const GET_RB_RECORDS = gql`
  query getRbRecords($id: String!) {
    all_rb_record(where: { user_id: { _eq: $id }, quantity: { _gt: 0 } }) {
      user_id
      quantity
      package
      order_type
      name
      value
      create_date
      id
      rounded_value
    }
    check_rb_balance(
      where: { user_id: { _eq: $id } }
      order_by: { unit_price: asc }
    ) {
      user_id
      package_id
      package_name
      package_chinese_name
      quantity
      unit_price
      total_value
    }
  }
`;

interface IProps {
  id: string;
}

const RBRecords: React.FC<IProps> = ({ id }) => {
  const { data, loading } = useQuery(GET_RB_RECORDS, {
    variables: {
      id,
    },
  });

  return (
    <div className=" w-full">
      <div className=" w-full p-3 border-b border-solid border-gray-100">
        <h1 className="mb-2">Balances</h1>
        {!loading &&
          data?.check_rb_balance?.map((rec, index) => (
            <div
              key={`${index}_${rec.package_id}`}
              className="w-full my-3 flex"
            >
              <div className="w-full flex justify-between items-center">
                <div>
                  <Paragraph>{rec.unit_price}</Paragraph>
                  <Label>{rec.package_chinese_name}</Label>
                </div>
                <div className=" flex flex-col justify-end items-end">
                  <Label>{rec.total_value}</Label>
                  <Paragraph>
                    {rec.quantity} x {(rec.unit_price * 0.3).toFixed(2)}
                  </Paragraph>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className=" p-3">
        <h1>Records</h1>
        {!loading &&
          data?.all_rb_record?.map((record, index) => (
            <div key={`${record.id}_${index}`} className=" my-3">
              <div className=" w-full flex justify-between items-center mb-1">
                <Paragraph>Order ID: {record.id}</Paragraph>
                <Paragraph>{getDateWithTime(record.create_date)}</Paragraph>
              </div>
              <div className=" w-full flex justify-between items-center">
                <Label>{record.name}</Label>
                <Label>
                  {record.quantity} x {record.rounded_value}
                </Label>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default RBRecords;
